import { PlatformConfigType } from 'dashboard/models/platform-node';

export const NODE_TYPE_TO_LABEL: Record<PlatformConfigType, string> = {
  [PlatformConfigType.AccountType]: 'Account type',
  [PlatformConfigType.CaseTemplate]: 'Case template',
  [PlatformConfigType.InquiryTemplate]: 'Inquiry template',
  [PlatformConfigType.InquiryTemplateVersion]: 'Inquiry template',
  [PlatformConfigType.List]: 'List',
  [PlatformConfigType.ReportTemplate]: 'Report template',
  [PlatformConfigType.ReportTemplateVersion]: 'Report template',
  [PlatformConfigType.TxnType]: 'Transaction type',
  [PlatformConfigType.VerificationTemplate]: 'Verification template',
  [PlatformConfigType.VerificationTemplateVersion]: 'Verification template',
  [PlatformConfigType.Workflow]: 'Workflow',
  [PlatformConfigType.WorkflowVersion]: 'Workflow',
};
